<template>
  <div class="edit-results-team-card">
    <div class="header">
      <h2>
        {{ model.match.name }}
      </h2>
      <span v-if="model.did_not_connect" class="dnc-badge">Не подключилась к лобби</span>
      <div v-else class="ranking-points">
        <template v-if="!isEditForm">
          <img :src="RankingPointsIcon" alt="" />
          <span>{{ model.place }}</span>
        </template>
        <template v-else>
          <div class="input-group">
            <span class="title-property">Place №</span>
            <b-input v-model.number="model.place"
                     class="no-spin"
                     type="number" style="width: 100% !important; max-width: none;" />
          </div>
        </template>
      </div>
    </div>
    <div v-if="!model.did_not_connect" class="players">
      <div v-for="player in model.groupMatchResultPlayers" class="player" :key="'player-result-' + player.id + player.user.username">
        <div class="header">
          <h3>{{ player.user.gameProfile.fields.nick }}</h3>
          <span class="property">id: {{ player.user.gameProfile.fields.pubg_id }}</span>
        </div>
        <div class="interactive">
          <div class="property">
            <template v-if="!isEditForm">
              <img class="icon" :src="GunIcon" alt="" />
              {{ player.kill_pts }}
            </template>
            <template v-else>
              <div class="input-group">
                <span class="title-property">Кол-во убийств</span>
                <b-input
                    class="no-spin"
                    v-model.number="player.kill_pts" type="number" />
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="actions">
      <label v-if="!isCompletedTournament" class="dnc-toggle" :class="{ active: model.did_not_connect }">
        <input type="checkbox" v-model="model.did_not_connect" @change="onDidNotConnectChange" />
        <span>Не подключилась к лобби</span>
      </label>
      <button v-if="!isEditForm && !isCompletedTournament && !model.did_not_connect" @click="isEditForm = true">Редактировать</button>
<!--      <template v-else>-->
<!--        <button @click="isEditForm = false">Сбросить изменения</button>-->
<!--      </template>-->
    </div>
  </div>
</template>

<script>
import GunIcon from '@/assets/icons/gun.svg'
import RankingPointsIcon from '@/assets/icons/ranking-points.svg'
import {mapGetters} from "vuex";

export default {
  name: "EditResultsTeamCard",
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters('moduleNewTournament', ['isCompletedTournament']),
    model: {
      get() { return this.value },
      set(newValue) { this.$emit('newValue', newValue) }
    }
  },
  data() {
    return {
      GunIcon,
      RankingPointsIcon,
      isEditForm: false
    }
  },
  methods: {
    onDidNotConnectChange() {
      // Отметка "не подключилась к лобби" делает место/убийства неактуальными —
      // выходим из режима редактирования, чтобы не путать администратора.
      if (this.model.did_not_connect) this.isEditForm = false
    }
  }
}
</script>

<style scoped lang="scss">
input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
}
/* Vue 2 */
.no-spin >>> input::-webkit-outer-spin-button,
.no-spin >>> input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
.no-spin >>> input {
  -moz-appearance: textfield;
  appearance: textfield;
}

.edit-results-team-card {
  background: white;
  padding: 20px;
  border-radius: 10px;
  margin-top: 20px;

  h2 {
    font-size: 19px;
    margin: 0;

    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  & > .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .ranking-points {
      margin-left: 10px;

      display: flex;
      align-items: center;
      justify-content: flex-start;

      img {
        height: 24px;
        margin-right: 5px;
      }

      span {
        font-size: 16px;
        font-weight: 300;
      }
    }
  }

  .dnc-badge {
    margin-left: 10px;
    display: inline-flex;
    align-items: center;
    padding: 4px 12px;
    border-radius: 13px;
    font-size: 12px;
    font-weight: 500;
    color: #d92d20;
    background: #fee4e2;
    border: 1px solid #fda29b;
  }

  .actions {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;

    .dnc-toggle {
      margin: 0 auto 0 0;
      display: inline-flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      font-size: 12px;
      color: #000000bf;
      user-select: none;

      input {
        width: 16px;
        height: 16px;
        margin: 0;
        cursor: pointer;
        accent-color: #d92d20;
      }

      &.active {
        color: #d92d20;
        font-weight: 500;
      }
    }

    button {
      display: block;
      font-size: 11px;
      border-radius: 13px;
      padding: 5px 13px 5px 13px;
      background: white;
      color: #000000bf;
      border: 1px solid #000000bf;
      transition: .2s;

      &:hover {
        background: #000000bf;
        color: white;
      }
    }
  }

  .players {
    margin-top: 20px;

    & > .player:not(:last-child) {
      border-bottom: 1px solid #d7d7d7;
      padding-bottom: 10px;
      margin-bottom: 10px;
    }

    .player {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .interactive {
        .icon {
          width: 17px;
        }
        .property {
          display: flex;
          gap: 10px;
          align-items: center;
        }
      }

      .header {
        h3 {
          font-size: 16px;
          margin: 0;
        }
        .property {
          color: #aaaaaa;
          font-size: 13px;
        }
      }
    }
  }

  .title-property {
    color: gray !important;
    font-size: 13px !important;
    font-weight: 400 !important;
  }

  .input-group {
    display: flex;
    flex-direction: column;

    & > * {
      width: 100%;
    }

    input {
      width: auto !important;
      max-width: 120px;
    }
  }
}
</style>